<div class="expired-search-text semibold">
  <span class="expired-search-text__information--not_mobile">{{ __('informer.search_results_expired') }}</span>
  <span class="expired-search-text__information--mobile">{% unsafe __('informer.search_results_expired_short') %}</span>
  &nbsp;<a class="expired-search-reload semibold" role="informer-restart-search-trigger">{{ __('informer.update_results') }}</a>
</div>
